import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from './../../../shared/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InvestmentsSimulationComponent } from './investments-simulation.component';
import { InvestComponent } from './invest/invest.component';
import { InvestmentsOptionsComponent } from './investments-options/investments-options.component';
import { InvestmentsConfirmationComponent } from './investments-confirmation/investments-confirmation.component';
import { InvestmentsSimulationService } from './investments-simulation.service';
import { MatProgressSpinnerModule } from '@angular/material';
import { CurrencyMaskModule } from 'ngx-currency-mask';
import { InvestmentsResultComponent } from './investments-result/investments-result.component';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		MatButtonModule,
		MatInputModule,
		FormsModule,
		ReactiveFormsModule,
		MatProgressSpinnerModule,
		CurrencyMaskModule
	],
	declarations: [
		InvestmentsSimulationComponent,
		InvestComponent,
		InvestmentsOptionsComponent,
		InvestmentsConfirmationComponent,
		InvestmentsResultComponent
	],
	exports: [
		InvestmentsSimulationComponent
	],
	providers: [
		InvestmentsSimulationService
	]
})
export class InvestmentsSimulationModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/investments/investments-simulation/investments-simulation.module.ts